import { render, staticRenderFns } from "./OrderCardPositions.vue?vue&type=template&id=02a74d20&scoped=true"
import script from "./OrderCardPositions.vue?vue&type=script&lang=ts"
export * from "./OrderCardPositions.vue?vue&type=script&lang=ts"
import style0 from "./OrderCardPositions.vue?vue&type=style&index=0&id=02a74d20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a74d20",
  null
  
)

export default component.exports